export default "__VITE_ASSET__D26uaa6I__"